import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { VERIFICAR_ITINERARIO_ATIVO_OU_INATIVO } from '../types';

export function verificarItinerarioAtivoOuInativo(codigoItinerario) {
    const url = `${URL}/itinerario/${codigoItinerario}/verificar-itinerario-ativo-ou-inativo`;
        
    return dispatch => axios.get(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: VERIFICAR_ITINERARIO_ATIVO_OU_INATIVO,
        payload: response
        })
    );
}